import script from "./ApproveTireModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApproveTireModal.vue?vue&type=script&setup=true&lang=ts"

import "./ApproveTireModal.vue?vue&type=style&index=0&id=06d94fa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d94fa1"]])

export default __exports__